import { render, staticRenderFns } from "./Alarm.vue?vue&type=template&id=638e9fc3&scoped=true"
import script from "./Alarm.vue?vue&type=script&lang=js"
export * from "./Alarm.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Alarm.vue?vue&type=style&index=1&id=638e9fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e9fc3",
  null
  
)

/* custom blocks */
import block0 from "./Alarm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports